// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1mvRz","title":"AfterBackImages_title__13DEf","images":"AfterBackImages_images__1Pcwy"};